import * as React from "react";
import {
  List,
  Datagrid,
  ListProps,
  TextField,
  DateField,
  Loading,
  FunctionField,
} from "react-admin";
import Pagination from "../Components/Pagination";
import { gql } from "@apollo/client";
import { authUserServiceClient } from "../util/AuthUsersServiceApolloClient";

const GET_AUTH_USER_BY_ROLE = gql`
  query getAuthUserByRole($where: AuthUserWhereInput) {
    authUsers(where: $where) {
      id
      firstName
      lastName
    }
  }
`;
const _convertArrayToObject = (array: any, key: any) => {
  const initialValue = {};
  return array.reduce((obj: any, item: any) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};

export const TellerSettlementList = (props: ListProps): React.ReactElement => {
  const [authUserList, setAuthUserList] = React.useState<any>(null);
  const [authUserListLoading, setAuthUserListLoading] = React.useState(false);
  const getAuthUserList = async () => {
    setAuthUserListLoading(true);
    try {
      const res = await authUserServiceClient.query({
        query: GET_AUTH_USER_BY_ROLE,
        variables: {
          where: {
            roles: {
              path: ["doctor_sale"],
              array_contains: ["doctor_sale.doctor"],
            },
          },
        },
      });
      setAuthUserListLoading(false);
      const authUsers = res.data.authUsers;
      setAuthUserList(_convertArrayToObject(authUsers, "id"));
    } catch (error) {
      setAuthUserList(null);
      setAuthUserListLoading(false);
    }
  };
  React.useEffect(() => {
      getAuthUserList();
  }, []);
  return !authUserList ? (
    <Loading />
  ) : (
    <List
      {...props}
      bulkActionButtons={false}
      title={"واریزی ها"}
      perPage={50}
      pagination={<Pagination />}
    >
      <Datagrid rowClick={"show"}>
        {/* <TextField label="ID" source="id" /> */}
        <FunctionField label="مبلغ" render={(record: any) => {
          return <p>{record.amount} ریال</p>
        }} />
        <DateField source="createdAt" label="تاریخ ایجاد" />
        <TextField label="ایجاد توسط" source="createdBy" />
        <TextField label="شماره حساب مبدا" source="sourceAccountNo" />
        <TextField label="شماره حساب مقصد" source="destinationAccountNo" />
        {/* <TextField label="شناسه پزشک" source="doctorId" /> */}
        <FunctionField
          label="نام و نام خوانوادگی پزشک"
          render={(record: any) => {
            return authUserList![record.doctorId]
              ? `${authUserList![record.doctorId].firstName} ${
                  authUserList![record.doctorId].lastName
                }`
              : "نامشخص";
          }}
        />

        <DateField label="تاریخ واریز" source="settledAt" />
        <TextField label="وضعیت پرداخت" source="status" />
        <DateField source="updatedAt" label="تاریخ بروزرسانی" />
        <TextField label="بروزرسانی توسط" source="updatedBy" />
      </Datagrid>
    </List>
  );
};
